"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createIntermediateFieldProposals = exports.isRequiredIntermediateFieldName = exports.getIntermediateCalcValidFieldTypes = exports.RequiredIntermediateFieldNames = void 0;
const _ = __importStar(require("lodash"));
const RequiredIntermediateFields = {
    assignmentExclusion: ['string'],
    exposure: ['float'],
    originalOwnerSlug: ['string'],
    waiveAllEligibility: ['boolean'],
    waiveAllConcentration: ['boolean'],
    includeInConcentrationLimitDenominatorIfWaived: ['boolean'],
    normalizedDaysPastDue: [
        'integer',
        'optionalInteger',
        'float',
        'optionalFloat',
    ],
    normalizedDurationDays: [
        'integer',
        'optionalInteger',
        'float',
        'optionalFloat',
    ],
    normalizedisChargedOff: ['boolean', 'optionalBoolean'],
    normalizedisDelinquent: ['boolean', 'optionalBoolean'],
    normalizedOriginationDate: ['date', 'optionalDate'],
    normalizedInitialBalance: ['float', 'optionalFloat'],
};
exports.RequiredIntermediateFieldNames = Object.keys(RequiredIntermediateFields);
// given an intermediate calc field, return the valid field types
const getIntermediateCalcValidFieldTypes = (field) => {
    return RequiredIntermediateFields[field];
};
exports.getIntermediateCalcValidFieldTypes = getIntermediateCalcValidFieldTypes;
const isRequiredIntermediateFieldName = (test) => {
    return exports.RequiredIntermediateFieldNames.includes(test);
};
exports.isRequiredIntermediateFieldName = isRequiredIntermediateFieldName;
/**
 * Creates monaco-editor CompletionItem suggestions
 * @param usePrefix adds `requiredIntermediateFields` or `dynamicIntermediateFields` prefix onto suggestions for use outside of intermediate calc sections
 */
const createIntermediateFieldProposals = ({ intermediateCalcs, usePrefix = false, }) => {
    const [requiredItermediateCalcs, dynamicIntermediateCalcs,] = _.partition(intermediateCalcs, ({ field }) => (0, exports.isRequiredIntermediateFieldName)(field));
    return [
        ..._.map(requiredItermediateCalcs, ({ field, config: { type } }) => ({
            label: `${usePrefix ? 'requiredIntermediateFields.' : ''}${field}`,
            documentation: type,
            insertText: usePrefix ? `requiredIntermediateFields.${field}` : field,
        })),
        ..._.map(dynamicIntermediateCalcs, ({ field, config: { type } }) => ({
            label: `${usePrefix ? 'dynamicIntermediateFields.' : ''}${field}`,
            documentation: type,
            insertText: usePrefix ? `dynamicIntermediateFields.${field}` : field,
        })),
    ];
};
exports.createIntermediateFieldProposals = createIntermediateFieldProposals;
//# sourceMappingURL=RequiredIntermediateFields.js.map